import React, { ChangeEvent } from 'react'
import styled from 'styled-components'

import ErrorMessage from './ErrorMessage'

interface InputProps {
	value?: string,
	name: string,
	id?: string,
	placeholder?: string,
	onChange: (event: ChangeEvent) => void,
	className?: string,
	label: string,
	error?: string,
	type?: string 
}
export default ({
	value,
	name,
	id,
	placeholder,
	onChange,
	className,
	label,
	error,
	type
}: InputProps) => {
	const isError = !!error
	const finalClassName = `${className} ${isError && 'error'}`

	return (
		<>
			<label htmlFor={name} className="sr-only">{label}</label>
			<Input
				type={type}
				name={name}
				id={id}
				placeholder={placeholder}
				onChange={onChange}
				className={finalClassName}
				value={value}
			/>
			{isError && <ErrorMessage>{error}</ErrorMessage>}
		</>
	)
}


const Input = styled.input`
	width: 100%;
	max-width: 100%;
	height: 45px;
	border-radius: 22.5px;
	background-color: #ffffff;
	margin-bottom: 10px;
	border: 1px solid #e5e5e5;
	padding-left: 20px;
	font-size: 16px;
	letter-spacing: 0;
	line-height: 26px;
	padding-top: 2px;
	font-family: "Adelle Sans";

	&:focus {
		outline: none;
	}

	::-webkit-input-placeholder {
		/* Edge */
		color: #808080;
		font-family: "Adelle Sans";
		font-size: 16px;
		letter-spacing: 0;
		line-height: 24px;
	}

	:-ms-input-placeholder {
		/* Internet Explorer 10-11 */
		color: #808080;
		font-family: "Adelle Sans";
		font-size: 16px;
		letter-spacing: 0;
		line-height: 24px;
	}

	::placeholder {
		color: #808080;
		font-family: "Adelle Sans";
		font-size: 16px;
		letter-spacing: 0;
		line-height: 24px;
	}

	&.error {
		border: 2px solid rgba(240, 52, 52, 1);
	}
`